import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle, faInfo } from "@fortawesome/pro-solid-svg-icons";
import cx from "classnames";

interface InfoBannerProps {
  prefix?: string;
  text?: string;
  children?: React.ReactNode;
  className?: string;
  textClassName?: string;
  margin?: string;
  colour?: "STANDARD" | "SUBTLE";
}

/** Renders the children, if supplied, otherwise falls back to displaying the text prop */
function InfoBanner({
  prefix,
  text,
  children,
  className,
  textClassName = "text-sm",
  margin = "mb-2",
  colour = "STANDARD",
}: InfoBannerProps) {
  const isUsingChildrenElements = children != null && children != undefined;
  const colourClasses =
    colour === "STANDARD"
      ? "bg-blue-50 text-blue-500 border-l-blue-500 border-l-2"
      : colour === "SUBTLE"
      ? "bg-gray-100 text-gray-500"
      : "";

  return (
    <div
      className={cx(
        "py-1 px-4 rounded-y-md",
        colourClasses,
        className,
        textClassName,
        margin,
        isUsingChildrenElements ? "flex" : ""
      )}
    >
      <div
        className={cx(
          "fa-layers fa-fw mr-1",
          isUsingChildrenElements ? "mt-1" : ""
        )}
      >
        <FontAwesomeIcon icon={faCircle}></FontAwesomeIcon>
        <FontAwesomeIcon icon={faInfo} size="xs" className="text-white" />
      </div>
      {prefix && <span className="font-semibold mr-1">{prefix}</span>}
      {children ? children : text}
    </div>
  );
}

export default InfoBanner;
